import { render, staticRenderFns } from "./multiCheck.vue?vue&type=template&id=64122d1a"
import script from "./multiCheck.vue?vue&type=script&lang=js"
export * from "./multiCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports